export const WEFAT_FEEDBACK_API_NAMES = Object.freeze([
    'showToast',
    'hideToast',
    'showLoading',
    'hideLoading',
]);
export const WEFAT_FEEDBACK_STYLES = [
    '.wefat-feedback-overlay {',
    '  position: fixed;',
    '  inset: 0;',
    '  z-index: 1100;',
    '  display: grid;',
    '  place-items: center;',
    '  width: 100%;',
    '  height: 100%;',
    '  padding: max(24px, env(safe-area-inset-top, 0px)) max(24px, env(safe-area-inset-right, 0px)) max(24px, env(safe-area-inset-bottom, 0px)) max(24px, env(safe-area-inset-left, 0px));',
    '  pointer-events: none;',
    '  isolation: isolate;',
    '}',
    '.wefat-feedback-overlay[data-wefat-mask="true"] {',
    '  background: rgb(0 0 0 / 1%);',
    '  pointer-events: auto;',
    '  touch-action: none;',
    '}',
    '.wefat-feedback-toast, .wefat-feedback-loading {',
    '  display: flex;',
    '  flex-direction: column;',
    '  align-items: center;',
    '  justify-content: center;',
    '  gap: 12px;',
    '  width: 136px;',
    '  min-height: 136px;',
    '  max-width: calc(100vw - 48px);',
    '  padding: 20px 16px;',
    '  overflow: hidden;',
    '  color: #ffffff;',
    '  text-align: center;',
    '  background-color: rgb(17 17 17 / 88%);',
    '  border-radius: 8px;',
    '  box-shadow: 0 6px 24px rgb(0 0 0 / 20%);',
    '  animation: wefat-feedback-enter 120ms ease-out both;',
    '  -webkit-backdrop-filter: blur(4px);',
    '  backdrop-filter: blur(4px);',
    '}',
    '.wefat-feedback-overlay[data-wefat-icon="none"] .wefat-feedback-toast {',
    '  width: auto;',
    '  min-width: 96px;',
    '  min-height: 48px;',
    '  max-width: min(calc(100vw - 48px), 320px);',
    '  padding: 12px 18px;',
    '}',
    '.wefat-feedback-toast__title, .wefat-feedback-loading__title {',
    '  max-width: 100%;',
    '  margin: 0;',
    '  overflow-wrap: anywhere;',
    '  font-size: 15px;',
    '  font-weight: 400;',
    '  line-height: 1.4;',
    '  white-space: pre-wrap;',
    '}',
    '.wefat-feedback-toast__icon, .wefat-feedback-loading__spinner {',
    '  position: relative;',
    '  flex: 0 0 44px;',
    '  width: 44px;',
    '  height: 44px;',
    '}',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="success"] {',
    '  border: 2px solid currentColor;',
    '  border-radius: 50%;',
    '}',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="success"]::after {',
    '  position: absolute;',
    '  top: 11px;',
    '  left: 10px;',
    '  width: 19px;',
    '  height: 10px;',
    '  content: "";',
    '  border-bottom: 3px solid currentColor;',
    '  border-left: 3px solid currentColor;',
    '  transform: rotate(-45deg);',
    '}',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="error"] {',
    '  border: 2px solid currentColor;',
    '  border-radius: 50%;',
    '}',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="error"]::before,',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="error"]::after {',
    '  position: absolute;',
    '  top: 19px;',
    '  left: 9px;',
    '  width: 22px;',
    '  height: 3px;',
    '  content: "";',
    '  background: currentColor;',
    '  border-radius: 2px;',
    '}',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="error"]::before { transform: rotate(45deg); }',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="error"]::after { transform: rotate(-45deg); }',
    '.wefat-feedback-toast__icon[data-wefat-toast-icon="loading"], .wefat-feedback-loading__spinner {',
    '  border: 3px solid rgb(255 255 255 / 35%);',
    '  border-top-color: #ffffff;',
    '  border-radius: 50%;',
    '  animation: wefat-feedback-spin 800ms linear infinite;',
    '}',
    '.wefat-feedback-toast__image {',
    '  display: block;',
    '  flex: 0 0 48px;',
    '  width: 48px;',
    '  height: 48px;',
    '  object-fit: contain;',
    '  border-radius: 4px;',
    '}',
    '@keyframes wefat-feedback-enter {',
    '  from { opacity: 0; transform: scale(0.96); }',
    '  to { opacity: 1; transform: scale(1); }',
    '}',
    '@keyframes wefat-feedback-spin { to { transform: rotate(360deg); } }',
    '@media (prefers-reduced-motion: reduce) {',
    '  .wefat-feedback-toast, .wefat-feedback-loading,',
    '  .wefat-feedback-toast__icon[data-wefat-toast-icon="loading"], .wefat-feedback-loading__spinner {',
    '    animation: none;',
    '  }',
    '}',
].join('\n');
const CALLBACK_KEYS = new Set(['success', 'fail', 'complete']);
const TOAST_KEYS = new Set(['title', 'icon', 'image', 'duration', 'mask', ...CALLBACK_KEYS]);
const LOADING_KEYS = new Set(['title', 'mask', ...CALLBACK_KEYS]);
const DEFAULT_TOAST_DURATION = 1_500;
export class WxFeedbackRuntimeError extends Error {
    code;
    errCode;
    errMsg;
    api;
    remediation;
    constructor(code, api, reason, remediation, cause) {
        const errMsg = `${api}:fail ${reason}`;
        super(`${code} ${errMsg}`);
        this.name = 'WxFeedbackRuntimeError';
        this.code = code;
        this.errCode = code;
        this.errMsg = errMsg;
        this.api = api;
        this.remediation = remediation;
        if (cause !== undefined) {
            Object.defineProperty(this, 'cause', {
                configurable: false,
                enumerable: false,
                value: cause,
                writable: false,
            });
        }
    }
}
function environmentError(api, reason, cause) {
    return new WxFeedbackRuntimeError('WF6130', api, reason, 'Run this adapter in a browser document or inject a complete BrowserFeedbackEnvironment.', cause);
}
function optionError(api, reason) {
    return new WxFeedbackRuntimeError('WF6131', api, reason, 'Pass the documented feedback options with direct data properties and callable callbacks.');
}
function domError(api, reason, cause) {
    return new WxFeedbackRuntimeError('WF6132', api, reason, 'Wait until document.body exists or configure a browser document adapter before calling this API.', cause);
}
function isObjectLike(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function isPlainRecord(value) {
    if (!isObjectLike(value)) {
        return false;
    }
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
function readOptions(api, rawOptions, allowedKeys) {
    if (rawOptions === undefined) {
        return Object.create(null);
    }
    if (!isPlainRecord(rawOptions)) {
        throw optionError(api, 'options must be a plain object');
    }
    for (const key of Reflect.ownKeys(rawOptions)) {
        const descriptor = typeof key === 'string'
            ? Object.getOwnPropertyDescriptor(rawOptions, key)
            : undefined;
        if (typeof key !== 'string' || !allowedKeys.has(key)) {
            throw optionError(api, `unsupported option field ${String(key)}`);
        }
        if (descriptor === undefined || !('value' in descriptor)) {
            throw optionError(api, `option field ${key} must be a direct data property`);
        }
        if (CALLBACK_KEYS.has(key) && descriptor.value !== undefined && typeof descriptor.value !== 'function') {
            throw optionError(api, `${key} must be a function when provided`);
        }
    }
    return rawOptions;
}
function requiredTitle(api, options) {
    const title = options.title;
    if (typeof title !== 'string' || title.length === 0 || title.length > 1_024) {
        throw optionError(api, 'title must be a non-empty string of at most 1024 characters');
    }
    return title;
}
function optionalBoolean(api, options, key) {
    const value = options[key];
    if (value !== undefined && typeof value !== 'boolean') {
        throw optionError(api, `${key} must be a boolean when provided`);
    }
    return value === true;
}
function callbacks(options) {
    const success = options.success;
    const fail = options.fail;
    const complete = options.complete;
    return {
        ...(success === undefined ? {} : { success }),
        ...(fail === undefined ? {} : { fail }),
        ...(complete === undefined ? {} : { complete }),
    };
}
function invokeCallback(callback, value, api, kind, report) {
    if (callback === undefined) {
        return;
    }
    try {
        callback(value);
    }
    catch (error) {
        if (report !== undefined) {
            try {
                report(error, api, kind);
                return;
            }
            catch (reportError) {
                queueMicrotask(() => { throw reportError; });
                return;
            }
        }
        queueMicrotask(() => { throw error; });
    }
}
function browserEnvironment() {
    if (typeof document === 'undefined') {
        return null;
    }
    return {
        document: document,
        setTimeout: (handler, timeout) => globalThis.setTimeout(handler, timeout),
        clearTimeout: (handle) => globalThis.clearTimeout(handle),
    };
}
export function createBrowserFeedbackWxApis(options = {}) {
    if (options.onCallbackError !== undefined && typeof options.onCallbackError !== 'function') {
        throw new TypeError('onCallbackError must be a function when provided');
    }
    const resolvedEnvironment = options.environment ?? browserEnvironment();
    if (resolvedEnvironment === null
        || !isObjectLike(resolvedEnvironment.document)
        || typeof resolvedEnvironment.document.createElement !== 'function'
        || typeof resolvedEnvironment.setTimeout !== 'function'
        || typeof resolvedEnvironment.clearTimeout !== 'function') {
        throw new TypeError('createBrowserFeedbackWxApis requires a browser document or injected environment');
    }
    const environment = resolvedEnvironment;
    let toastElement = null;
    let loadingElement = null;
    let toastTimer = null;
    function body(api) {
        const current = environment.document.body;
        if (current === null || current === undefined) {
            throw domError(api, 'document.body is not available');
        }
        return current;
    }
    function remove(api, element) {
        if (element === null) {
            return;
        }
        try {
            body(api).removeChild(element);
        }
        catch (error) {
            throw domError(api, 'could not remove the feedback element', error);
        }
    }
    function makeElement(api, panelClassName, titleClassName, title, mask, rootAttributes = {}, panelAttributes = {}, visual = null) {
        try {
            const overlay = environment.document.createElement('div');
            overlay.className = 'wefat-feedback-overlay';
            overlay.setAttribute('data-wefat-feedback', api);
            if (mask) {
                overlay.setAttribute('data-wefat-mask', 'true');
            }
            for (const [name, value] of Object.entries(rootAttributes)) {
                overlay.setAttribute(name, value);
            }
            const panel = environment.document.createElement('div');
            panel.className = panelClassName;
            panel.setAttribute('role', 'status');
            panel.setAttribute('aria-live', 'polite');
            panel.setAttribute('aria-atomic', 'true');
            for (const [name, value] of Object.entries(panelAttributes)) {
                panel.setAttribute(name, value);
            }
            if (visual !== null) {
                const visualElement = environment.document.createElement(visual.tagName);
                visualElement.className = visual.className;
                for (const [name, value] of Object.entries(visual.attributes)) {
                    visualElement.setAttribute(name, value);
                }
                panel.appendChild(visualElement);
            }
            const titleElement = environment.document.createElement('span');
            titleElement.className = titleClassName;
            titleElement.textContent = title;
            panel.appendChild(titleElement);
            overlay.appendChild(panel);
            body(api).appendChild(overlay);
            return overlay;
        }
        catch (error) {
            if (error instanceof WxFeedbackRuntimeError) {
                throw error;
            }
            throw domError(api, 'could not create the feedback element', error);
        }
    }
    function clearToast() {
        if (toastTimer !== null) {
            environment.clearTimeout(toastTimer);
            toastTimer = null;
        }
        remove('hideToast', toastElement);
        toastElement = null;
    }
    function clearLoading() {
        remove('hideLoading', loadingElement);
        loadingElement = null;
    }
    function run(api, rawOptions, allowedKeys, operation) {
        let parsed;
        try {
            parsed = readOptions(api, rawOptions, allowedKeys);
        }
        catch (error) {
            return Promise.reject(error instanceof WxFeedbackRuntimeError
                ? error
                : optionError(api, 'invalid callback options'));
        }
        const callbackSet = callbacks(parsed);
        const task = Promise.resolve().then(() => operation(parsed));
        if (callbackSet.success === undefined
            && callbackSet.fail === undefined
            && callbackSet.complete === undefined) {
            return task;
        }
        void task.then((result) => {
            invokeCallback(callbackSet.success, result, api, 'success', options.onCallbackError);
            invokeCallback(callbackSet.complete, result, api, 'complete', options.onCallbackError);
        }, (error) => {
            const failure = error instanceof WxFeedbackRuntimeError
                ? error
                : environmentError(api, 'feedback operation failed', error);
            invokeCallback(callbackSet.fail, failure, api, 'fail', options.onCallbackError);
            invokeCallback(callbackSet.complete, failure, api, 'complete', options.onCallbackError);
        });
        return undefined;
    }
    const apis = {
        showToast: (rawOptions) => run('showToast', rawOptions, TOAST_KEYS, (parsed) => {
            const title = requiredTitle('showToast', parsed);
            const icon = parsed.icon;
            if (icon !== undefined && !['success', 'error', 'loading', 'none'].includes(String(icon))) {
                throw optionError('showToast', 'icon must be success, error, loading, or none');
            }
            const image = parsed.image;
            if (image !== undefined && (typeof image !== 'string' || image.length === 0)) {
                throw optionError('showToast', 'image must be a non-empty string when provided');
            }
            const duration = parsed.duration ?? DEFAULT_TOAST_DURATION;
            if (typeof duration !== 'number' || !Number.isInteger(duration) || duration < 0 || duration > 60_000) {
                throw optionError('showToast', 'duration must be an integer from 0 through 60000');
            }
            const mask = optionalBoolean('showToast', parsed, 'mask');
            clearToast();
            const visualKind = image === undefined ? String(icon ?? 'success') : 'image';
            const visual = visualKind === 'none'
                ? null
                : visualKind === 'image'
                    ? {
                        attributes: {
                            'aria-hidden': 'true',
                            alt: '',
                            decoding: 'async',
                            referrerpolicy: 'no-referrer',
                            src: image,
                        },
                        className: 'wefat-feedback-toast__image',
                        tagName: 'img',
                    }
                    : {
                        attributes: {
                            'aria-hidden': 'true',
                            'data-wefat-toast-icon': visualKind,
                        },
                        className: 'wefat-feedback-toast__icon',
                        tagName: 'span',
                    };
            toastElement = makeElement('showToast', 'wefat-feedback-toast', 'wefat-feedback-toast__title', title, mask, { 'data-wefat-icon': visualKind }, icon === 'error' ? { 'aria-live': 'assertive' } : {}, visual);
            if (duration > 0) {
                toastTimer = environment.setTimeout(() => {
                    clearToast();
                }, duration);
            }
            return { errMsg: 'showToast:ok' };
        }),
        hideToast: (rawOptions) => run('hideToast', rawOptions, CALLBACK_KEYS, () => {
            clearToast();
            return { errMsg: 'hideToast:ok' };
        }),
        showLoading: (rawOptions) => run('showLoading', rawOptions, LOADING_KEYS, (parsed) => {
            const title = requiredTitle('showLoading', parsed);
            const mask = optionalBoolean('showLoading', parsed, 'mask');
            clearLoading();
            loadingElement = makeElement('showLoading', 'wefat-feedback-loading', 'wefat-feedback-loading__title', title, mask, {}, { 'aria-busy': 'true' }, {
                attributes: { 'aria-hidden': 'true' },
                className: 'wefat-feedback-loading__spinner',
                tagName: 'span',
            });
            return { errMsg: 'showLoading:ok' };
        }),
        hideLoading: (rawOptions) => run('hideLoading', rawOptions, CALLBACK_KEYS, () => {
            clearLoading();
            return { errMsg: 'hideLoading:ok' };
        }),
    };
    return Object.freeze(apis);
}
//# sourceMappingURL=feedback-adapter.js.map